
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-flickr",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.222 15.746c0 4.07-3.267 7.365-7.111 7.365C3.075 23.111 0 19.816 0 15.746s3.267-7.365 7.111-7.365c3.844.194 7.111 3.295 7.111 7.365zm10.671-6.857c4.034 0 7.107 3.295 7.107 7.365s-3.266 7.365-7.107 7.365c-4.034 0-7.107-3.295-7.107-7.365-.192-4.264 3.073-7.365 7.107-7.365zm-.004 13.206c3.429 0 6.095-2.778 6.095-6.349s-2.667-6.349-6.095-6.349-6.095 2.778-6.095 6.349 2.667 6.349 6.095 6.349z"}})])
          )
        }
      }
    